import IncidentCategorySelectInput from './IncidentCategorySelectInput'
import { IncidentReportStatusSelectInput } from './IncidentReportStatusUI'
import OwnershipSelectInput from './OwnershipSelectInput'
import SeveritySelectInput from './SeveritySelectInput'

export const IncidentReportsStatusFilter = (props) => <IncidentReportStatusSelectInput {...props} validate={null} />

IncidentReportsStatusFilter.defaultProps = {
  source: 'status',
}

export const IncidentReportsSeverityFilter = (props) => <SeveritySelectInput {...props} validate={null} />

IncidentReportsSeverityFilter.defaultProps = {
  source: 'severity',
}

export const IncidentReportsOwnershipFilter = (props) => <OwnershipSelectInput {...props} validate={null} />

IncidentReportsOwnershipFilter.defaultProps = {
  source: 'ownership',
}

export const IncidentReportsCategoryFilter = (props) => <IncidentCategorySelectInput {...props} validate={null} />

IncidentReportsCategoryFilter.defaultProps = {
  source: 'category',
}
